import React, { Component } from "react";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import HelperClass from "../../../config/helperClass";
import { THEME_COLOR, THEME_TEXT_COLOR } from "../../../config/config";
import Select from "react-select";
import { listStages } from "./api/leads_api";
import { PRIORITIES, LEAD_SOURCES, FALLBACK_STAGES } from "./api/leads_constants";
import KanbanBoard from "./KanbanBoard";

const auth = new HelperClass();

const BottomPopper = (props) => (
  <Popper {...props} placement="bottom-start" modifiers={{ flip: { enabled: false } }} />
);

function fmtMoney(v) {
  var n = parseFloat(v) || 0;
  if (n >= 1000000) return "$" + (n / 1000000).toFixed(1) + "M";
  if (n >= 1000) return "$" + (n / 1000).toFixed(1) + "k";
  return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

/* ─── Component ───────────────────────────────────────────────────────── */
export default class LeadsKanban extends Component {
  state = {
    mobileMenuOpen: false,
    // board filters
    partner_filter: "",
    priority_filter: "",
    search: "",
    searchInput: "",
    refreshKey: 0,
    // partner list for filter dropdown
    partners: [],
    // add lead modal
    stages: FALLBACK_STAGES,
    showAdd: false,
    adding: false,
    addErr: "",
    partnersLoading: false,
    partnerProducts: [],
    form: {
      company: "", contact_name: "", email: "", phone: "",
      job_title: "", industry: "", website: "", address: "",
      deal_value: "", priority: "med", stage_key: "new",
      source: "", score: 50, next_action_date: "",
      partner_accountno: "", notes: "", products: [],
    },
  };

  componentDidMount() {
    // this.loadPartners();
    this.loadStages();
    this._onResize = () => { if (window.innerWidth >= 576) this.setState({ mobileMenuOpen: false }); };
    window.addEventListener("resize", this._onResize);
  }

  loadStages = async () => {
    try {
      const r = await listStages(auth.getAccount(), auth.getToken());
      if (r && r.data && r.data.status === 200 && Array.isArray(r.data.data) && r.data.data.length > 0) {
        this.setState({ stages: r.data.data });
      }
    } catch (_) {}
  };

  // loadPartners = async () => {
  //   try {
  //     const r = await listPartners(auth.getAccount(), auth.getToken());
  //     if (r && r.data && r.data.status === 200 && Array.isArray(r.data.data)) {
  //       this.setState({ partners: r.data.data });
  //     }
  //   } catch (_) {}
  // };

  onPartnerFilterChange = (option) => {
    this.setState({ partner_filter: option ? option.value : "" });
  };

  onPriorityFilterChange = (e) => {
    this.setState({ priority_filter: e.target.value });
  };

  onSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ searchInput: value });
    if (this._searchTimer) clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => {
      this.setState({ search: value });
    }, 400);
  };

  onSearchClear = () => {
    if (this._searchTimer) clearTimeout(this._searchTimer);
    this.setState({ search: "", searchInput: "" });
  };

  componentWillUnmount() {
    if (this._searchTimer) clearTimeout(this._searchTimer);
    window.removeEventListener("resize", this._onResize);
  }

  /* ─── Add Lead Modal Methods ──────────────────────────────────────── */
  // openAddModal = async () => {
  //   this.setState({ showAdd: true, addErr: "", adding: false, partnersLoading: true });
  //   try {
  //     const r = await listPartners(auth.getAccount(), auth.getToken());
  //     if (r && r.data && r.data.status === 200) {
  //       this.setState({ partners: r.data.data || [], partnersLoading: false });
  //     } else {
  //       const msg = (r && r.data && (r.data.message || (r.data.errors && r.data.errors.message))) || "Could not load partner list.";
  //       this.setState({ partnersLoading: false, addErr: msg });
  //     }
  //   } catch (e) {
  //     this.setState({ partnersLoading: false, addErr: "Could not load partners: " + String(e && e.message ? e.message : e) });
  //   }
  // };

  // closeAddModal = () => this.setState({
  //   showAdd: false, addErr: "", partnersLoading: false, partnerProducts: [],
  //   form: {
  //     company: "", contact_name: "", email: "", phone: "",
  //     job_title: "", industry: "", website: "", address: "",
  //     deal_value: "", priority: "med", stage_key: "new",
  //     source: "", score: 50, next_action_date: "",
  //     partner_accountno: "", notes: "", products: [],
  //   },
  // });

  patchForm = (key, val) => this.setState((s) => ({ form: { ...s.form, [key]: val } }));

  onAddressSelect = (place) => {
    const description = place && place.value && place.value.description ? place.value.description : "";
    this.patchForm("address", description);
  };

  // onPartnerChangeModal = async (partner_accountno) => {
  //   this.patchForm("partner_accountno", partner_accountno);
  //   this.patchForm("products", []);
  //   this.patchForm("deal_value", "");
  //   if (!partner_accountno) { this.setState({ partnerProducts: [] }); return; }
  //   try {
  //     const r = await listPartnerProducts(auth.getAccount(), auth.getToken(), partner_accountno);
  //     if (r && r.data && r.data.status === 200) {
  //       this.setState({ partnerProducts: r.data.data || [] });
  //     }
  //   } catch (_) {}
  // };

  recalcDealValue = (products) => {
    const total = (products || []).reduce((sum, p) => sum + (parseFloat(p.rate) || 0), 0);
    return total > 0 ? total.toFixed(2) : "";
  };

  addProduct = (svc) => {
    this.setState((s) => {
      const products = [
        ...(s.form.products || []),
        { service_id: svc.service_id, service_title: svc.service_title, rate: svc.rate },
      ];
      return { form: { ...s.form, products, deal_value: this.recalcDealValue(products) } };
    });
  };

  removeProductAt = (index) => {
    this.setState((s) => {
      const products = (s.form.products || []).filter((_, i) => i !== index);
      return { form: { ...s.form, products, deal_value: this.recalcDealValue(products) } };
    });
  };

  // submitAddLead = async () => {
  //   const { form } = this.state;
  //   if (!form.company.trim()) { this.setState({ addErr: "Company name is required." }); return; }
  //   this.setState({ adding: true, addErr: "" });
  //   const payload = Object.assign({}, form, {
  //     products: JSON.stringify(form.products || []),
  //   });
  //   try {
  //     const r = await createLead(auth.getAccount(), auth.getToken(), payload);
  //     if (r && r.data && r.data.status === 200) {
  //       this.closeAddModal();
  //       // refreshKey change causes KanbanBoard to re-fetch
  //       this.setState(function(s) { return { refreshKey: s.refreshKey + 1 }; });
  //     } else {
  //       const msg = (r && r.data && (r.data.message || (r.data.errors && r.data.errors.message))) || "Failed to create lead";
  //       this.setState({ adding: false, addErr: msg });
  //     }
  //   } catch (e) {
  //     this.setState({ adding: false, addErr: "Error creating lead: " + String(e && e.message ? e.message : e) });
  //   }
  // };

  /* ─── render ─────────────────────────────────────────────────────── */
  render() {
    const { partner_filter, priority_filter, search, searchInput, refreshKey, partners, stages, showAdd, adding, addErr, partnersLoading, partnerProducts, form } = this.state;

    const kanbanFilters = {
      partner_accountno: partner_filter || undefined,
      priority: priority_filter || undefined,
      search: search || undefined,
      per_column: 20,
      refreshKey: refreshKey,
    };

    return (
      <div className="nk-content">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">

              {/* ── header ── */}
              <div className="nk-block-head nk-block-head-sm" style={{ marginBottom: 16 }}>
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">Pipeline — Kanban</h3>
                    <div className="nk-block-des text-soft">
                      <p>Drag cards between stages to update the pipeline.</p>
                    </div>
                  </div>
                  <div className="nk-block-head-content" id="HeadContentKanban">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a href="#" className="btn btn-icon btn-trigger toggle-expand mr-n1" data-target="kanbanMenu">
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div className="toggle-expand-content" data-content="kanbanMenu">
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <Link to="/crm_leads" className="btn btn-info" style={{ color: "#fff" }}>
                              <em className="icon ni ni-list"></em>&nbsp;<span>List View</span>
                            </Link>
                          </li>
                          <li className="nk-block-tools-opt">
                            <Link to="/crm_sales_funnel" className="btn btn-info" style={{ color: "#fff" }}>
                              <em className="icon ni ni-bar-chart"></em>&nbsp;<span>Funnel</span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── filters ── */}
              <div style={{ marginBottom: 16, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                {/* Partner filter disabled on agent side — the agent IS the partner
                <div style={{ minWidth: 180 }}>
                  <Select
                    isClearable
                    placeholder="All Partners"
                    value={partner_filter
                      ? { value: partner_filter, label: (partners.find(function(p) { return p.accountno === partner_filter; }) || {}).comp_name || partner_filter }
                      : null
                    }
                    onChange={this.onPartnerFilterChange}
                    options={partners.map(function(p) { return { value: p.accountno, label: p.comp_name || p.name }; })}
                    styles={{
                      control: function(b) { return Object.assign({}, b, { minHeight: 36, fontSize: 13 }); },
                      indicatorsContainer: function(b) { return Object.assign({}, b, { height: 36 }); },
                      valueContainer: function(b) { return Object.assign({}, b, { height: 36, padding: "0 8px" }); },
                    }}
                  />
                </div>
                */}
                <div style={{ minWidth: 140 }}>
                  <select
                    className="form-control form-control-sm"
                    value={priority_filter}
                    onChange={this.onPriorityFilterChange}
                    style={{ height: 36, fontSize: 13 }}
                  >
                    <option value="">All Priority</option>
                    {PRIORITIES.map(function(p) { return <option key={p.value} value={p.value}>{p.label}</option>; })}
                  </select>
                </div>
                <div style={{ flex: "1 1 200px", minWidth: 160, maxWidth: 320, position: "relative" }}>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search leads…"
                    value={searchInput}
                    onChange={this.onSearchChange}
                    style={{ height: 36, fontSize: 13, paddingRight: searchInput ? 28 : 10 }}
                  />
                  {searchInput && (
                    <button
                      type="button"
                      onClick={this.onSearchClear}
                      title="Clear search"
                      style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 0, color: "#9ca3af", fontSize: 14 }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </button>
                  )}
                </div>
              </div>

              {/* ── kanban board (self-managed, re-fetches on filter/refresh change) ── */}
              <div style={{ height: "calc(100vh - 240px)", overflow: "hidden" }}>
                <KanbanBoard
                  fullHeight={true}
                  filters={kanbanFilters}
                  onAddLead={this.openAddModal}
                  showAddBtn={true}
                />
              </div>

            </div>
          </div>
        </div>

        {/* ====== Add Lead Modal ====== */}
        {showAdd && (
          <div
            className="modal fade show"
            style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
            onClick={this.closeAddModal}
          >
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document" onClick={function(e) { e.stopPropagation(); }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add New Lead</h5>
                  <button type="button" className="close" onClick={this.closeAddModal}>
                    <em className="icon ni ni-cross"></em>
                  </button>
                </div>
                <div className="modal-body" style={{ overflowY: "auto", maxHeight: "65vh" }}>
                  {addErr ? <div className="alert alert-danger mb-3">{addErr}</div> : null}
                  <div className="row g-3">
                    {/* Company */}
                    <div className="col-md-6">
                      <TextField
                        required
                        fullWidth
                        variant="outlined"
                        label="Company"
                        value={form.company}
                        onChange={(e) => this.patchForm("company", e.target.value)}
                        inputProps={{ maxLength: 150, autoComplete: "off" }}
                      />
                    </div>
                    {/* Contact Name */}
                    <div className="col-md-6">
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Contact Name"
                        value={form.contact_name}
                        onChange={(e) => this.patchForm("contact_name", e.target.value)}
                        inputProps={{ maxLength: 120, autoComplete: "off" }}
                      />
                    </div>
                    {/* Email */}
                    <div className="col-md-6">
                      <TextField
                        fullWidth
                        variant="outlined"
                        type="email"
                        label="Email"
                        value={form.email}
                        onChange={(e) => this.patchForm("email", e.target.value)}
                        inputProps={{ autoComplete: "off" }}
                      />
                    </div>
                    {/* Phone */}
                    <div className="col-md-6">
                      <ReactPhoneInput
                        country="us"
                        value={(form.phone || "").replace(/^\+/, "")}
                        onChange={function(value) {
                          this.patchForm("phone", value ? "+" + value : "");
                        }.bind(this)}
                        inputProps={{ name: "phone", maxLength: 20 }}
                        specialLabel="Phone Number"
                        containerStyle={{ width: "100%" }}
                        inputStyle={{ width: "100%", height: "56px" }}
                        buttonStyle={{}}
                      />
                    </div>
                    {/* Job Title */}
                    <div className="col-md-6">
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Job Title"
                        value={form.job_title}
                        onChange={(e) => this.patchForm("job_title", e.target.value)}
                        inputProps={{ maxLength: 100, autoComplete: "off" }}
                      />
                    </div>
                    {/* Industry */}
                    <div className="col-md-6">
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Industry"
                        value={form.industry}
                        onChange={(e) => this.patchForm("industry", e.target.value)}
                        inputProps={{ maxLength: 100, autoComplete: "off" }}
                      />
                    </div>
                    {/* Deal Value (auto-calculated from selected products) */}
                    <div className="col-md-4">
                      <TextField
                        fullWidth
                        variant="outlined"
                        type="number"
                        label="Deal Value ($)"
                        value={form.deal_value}
                        disabled
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                        helperText="Auto-calculated from selected products"
                        inputProps={{ min: 0, autoComplete: "off" }}
                      />
                    </div>
                    {/* Priority */}
                    <div className="col-md-4">
                      <TextField
                        fullWidth
                        variant="outlined"
                        select
                        label="Priority"
                        value={form.priority}
                        onChange={(e) => this.patchForm("priority", e.target.value)}
                        SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 280 } } } }}
                      >
                        {PRIORITIES.map((p) => (
                          <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
                        ))}
                      </TextField>
                    </div>
                    {/* Stage */}
                    <div className="col-md-4">
                      <TextField
                        fullWidth
                        variant="outlined"
                        select
                        label="Stage"
                        value={form.stage_key}
                        onChange={(e) => this.patchForm("stage_key", e.target.value)}
                        SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 280 } } } }}
                      >
                        {stages.map((s) => (
                          <MenuItem key={s.stage_key} value={s.stage_key}>{s.label}</MenuItem>
                        ))}
                      </TextField>
                    </div>
                    {/* Source */}
                    <div className="col-md-6">
                      <TextField
                        fullWidth
                        variant="outlined"
                        select
                        label="Source"
                        value={form.source}
                        onChange={(e) => this.patchForm("source", e.target.value)}
                        SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 280 } } } }}
                      >
                        <MenuItem value="">-- Select Source --</MenuItem>
                        {LEAD_SOURCES.map((s) => (
                          <MenuItem key={s} value={s}>{s}</MenuItem>
                        ))}
                      </TextField>
                    </div>
                    {/* Next Action Date */}
                    <div className="col-md-6">
                      <TextField
                        fullWidth
                        variant="outlined"
                        type="date"
                        label="Next Action Date"
                        value={form.next_action_date}
                        onChange={(e) => this.patchForm("next_action_date", e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ autoComplete: "off" }}
                      />
                    </div>
                    {/* Partner */}
                    <div className="col-md-6">
                      <Autocomplete
                        options={partners.map((p) => ({
                          id: p.accountno,
                          label: `${p.comp_name || p.name}${p.email ? " (" + p.email + ")" : ""}`,
                        }))}
                        getOptionLabel={(option) => option.label || ""}
                        value={
                          form.partner_accountno
                            ? (() => {
                                const p = partners.find((x) => x.accountno === form.partner_accountno);
                                return p
                                  ? {
                                      id: p.accountno,
                                      label: `${p.comp_name || p.name}${p.email ? " (" + p.email + ")" : ""}`,
                                    }
                                  : null;
                              })()
                            : null
                        }
                        onChange={(e, newValue) => this.onPartnerChangeModal(newValue?.id || "")}
                        disabled={partnersLoading}
                        clearOnBlur={false}
                        clearOnEscape={false}
                        noOptionsText="No Partners"
                        PopperComponent={BottomPopper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Assign Partner"
                            variant="outlined"
                            fullWidth
                            placeholder={partnersLoading ? "Loading partners\u2026" : "-- No Partner --"}
                            inputProps={{ ...params.inputProps, autoComplete: "new-password" }}
                          />
                        )}
                      />
                    </div>
                    {/* Website */}
                    <div className="col-md-6">
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Website"
                        value={form.website}
                        onChange={(e) => this.patchForm("website", e.target.value)}
                        placeholder="https://"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ autoComplete: "off" }}
                      />
                    </div>
                    {/* Address */}
                    <div className="col-12">
                      <GooglePlacesAutocomplete
                        apiKey={process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}
                        apiOptions={{ loading: "async" }}
                        selectProps={{
                          value: form.address ? { label: form.address, value: form.address } : null,
                          onChange: this.onAddressSelect,
                          placeholder: "Search address\u2026",
                          isClearable: true,
                          styles: {
                            control: function(b) {
                              return Object.assign({}, b, { minHeight: 56, height: 56, fontSize: 14 });
                            },
                            valueContainer: function(b) {
                              return Object.assign({}, b, { height: 56, padding: "0 12px" });
                            },
                            input: function(provided) {
                              return Object.assign({}, provided, { color: "black", margin: 0, padding: 0 });
                            },
                            indicatorsContainer: function(b) {
                              return Object.assign({}, b, { height: 56 });
                            },
                            placeholder: function(b) {
                              return Object.assign({}, b, { color: "#8094ae" });
                            },
                            option: function(provided) {
                              return Object.assign({}, provided, { color: "black" });
                            },
                            singleValue: function(provided) {
                              return Object.assign({}, provided, { color: "black" });
                            },
                            menu: function(b) { return Object.assign({}, b, { zIndex: 9999 }); },
                          },
                        }}
                        className="googleLocation-autocomplete"
                      />
                    </div>
                    {/* Partner Products */}
                    {partnerProducts.length > 0 && (
                      <div className="col-12">
                        <label className="form-label" style={{ fontWeight: 600, fontSize: 13, color: "#526484", marginBottom: 6 }}>
                          Interested Products
                        </label>
                        {(form.products || []).length > 0 && (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
                            {form.products.map((p, idx) => (
                              <span
                                key={`${p.service_id}-${idx}`}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 6,
                                  padding: "4px 10px",
                                  background: "#e6f0ff",
                                  color: "#1c5bde",
                                  borderRadius: 14,
                                  fontSize: 12,
                                  fontWeight: 500,
                                }}
                              >
                                {p.service_title}
                                <span
                                  onClick={() => this.removeProductAt(idx)}
                                  style={{ cursor: "pointer", color: "#1c5bde", fontWeight: 700, lineHeight: 1 }}
                                  title="Remove"
                                >
                                  ×
                                </span>
                              </span>
                            ))}
                          </div>
                        )}
                        <Autocomplete
                          options={partnerProducts.map((svc) => ({
                            id: svc.service_id,
                            label: svc.service_title,
                            svc,
                          }))}
                          getOptionLabel={(option) => option.label || ""}
                          getOptionSelected={() => false}
                          value={null}
                          inputValue={this.state.productSearch || ""}
                          onInputChange={(e, newInput, reason) => {
                            if (reason === "input") this.setState({ productSearch: newInput });
                            else if (reason === "clear") this.setState({ productSearch: "" });
                          }}
                          onChange={(e, newValue) => {
                            if (newValue && newValue.svc) {
                              this.addProduct(newValue.svc);
                              this.setState({ productSearch: "" });
                            }
                          }}
                          disableCloseOnSelect
                          clearOnBlur={false}
                          clearOnEscape={false}
                          noOptionsText="No products"
                          PopperComponent={BottomPopper}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Search & select products…"
                              inputProps={{ ...params.inputProps, autoComplete: "new-password" }}
                            />
                          )}
                        />
                      </div>
                    )}
                    {/* Notes */}
                    <div className="col-12">
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Notes"
                        value={form.notes}
                        onChange={(e) => this.patchForm("notes", e.target.value)}
                        placeholder="Initial notes or context about this lead\u2026"
                        multiline
                        rows={3}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ autoComplete: "off" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-light" onClick={this.closeAddModal} disabled={adding}>Cancel</button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ color: "#fff" }}
                    disabled={adding || !form.company.trim()}
                    onClick={this.submitAddLead}
                  >
                    {adding ? "Saving\u2026" : "Create Lead"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}